module.exports = __webpack_public_path__ + "statics/img/icon-ad2.bb94a378.png";